import React, { useEffect, useRef } from "react";
import "./LandingPage1.css";

export default function LandingPage() {
  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;

    if (!slider) return;

    let position = 0;

    const speed = 0.5;

    const animate = () => {
      position -= speed;

      if (Math.abs(position) >= slider.scrollWidth / 2) {
        position = 0;
      }

      slider.style.transform = `translateX(${position}px)`;

      requestAnimationFrame(animate);
    };

    const animationFrame = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <div
      className="landing-page1"
      dir="rtl"
    >

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="hero">

        <div className="hero-content">

          <span className="hero-badge">
            נצר הובלות ומנופים בע״מ
          </span>

          <h1>
            <span>
              מקצועיות ! בטיחות ! אמינות !
            </span>
          </h1>

              <p>
    נצר הובלות ומנופים בע"מ מספקת שירותי הובלה, הרמה ושינוע בכל רחבי הארץ. אנו מתמחים בהובלת ציוד כבד, מכולות, קרוואנים, מבנים, ממ"דים ומיגוניות, מכונות וחומרי בניין. בנוסף אנו מספקים שירותי מנוף זרוע, מנוף סל, הרמת מבנים, הרמת זכוכית בוואקום והשכרת מנופי הרמה וסלי הרמה. צוות מקצועי, שירות אמין וזמינות גבוהה – עם פתרונות הובלה והרמה המותאמים לכל פרויקט !
          </p>

        </div>

      </section>


      {/* =====================================================
          SERVICES / CONTENT
      ===================================================== */}

      <section className="content">

        <div className="content-inner">

          <span className="section-label">
            השירותים שלנו
          </span>

          <h2>
            פתרונות הובלה ושינוע
            <br />
            לכל צורך
          </h2>

          <p className="content-intro">
            נצר הובלות ומנופים בע״מ מעניקה מגוון פתרונות
            מקצועיים בתחום ההובלות, המנופים והשינוע.
          </p>


          <ul className="services-list">

            <li>
              <span>✓</span>
              הובלות דירה ועסקים
            </li>

            <li>
              <span>✓</span>
              הובלות עם מנוף
            </li>

            <li>
              <span>✓</span>
              שירותי מנוף והרמה
            </li>

            <li>
              <span>✓</span>
              שינוע והובלת ציוד כבד
            </li>

            <li>
              <span>✓</span>
              הרמת ריהוט וציוד למקומות מורכבים
            </li>

            <li>
              <span>✓</span>
              פתרונות הובלה בהתאמה אישית
            </li>

          </ul>


          <p className="highlight">
            אנחנו כאן כדי לבצע את העבודה בצורה מקצועית,
            בטוחה ויעילה – מההובלה הראשונה ועד הפריט האחרון.
          </p>

        </div>

      </section>


      {/* =====================================================
          CLIENTS
      ===================================================== */}

      <section className="clients-section">

        <div className="clients-title">

          <span>
            בין לקוחותינו
          </span>

          <h2>
            עסקים ולקוחות שבחרו בנו
          </h2>

          <p>
            שירות אמין ומקצועי ללקוחות פרטיים ועסקיים.
          </p>

        </div>


        <div className="slider-wrapper">

          <div
            className="slider-track"
            ref={sliderRef}
          >

            {[...Array(6), ...Array(6)].map((_, i) => (

              <div
                key={i}
                className="slide"
              >

                <img
                  src={`/logos/${(i % 4) + 1}.png`}
                  alt={`לקוח ${((i % 4) + 1)}`}
                  loading="lazy"
                />

              </div>

            ))}

          </div>

        </div>

      </section>

    </div>
  );
}